import { InterestsPageComponent } from './interestsPageComponent'
import { useCreateInterests } from '../../api/interests'
import { useProject } from '../../api/project'
import { useProperties } from '../../api/properties'
import { useSignup } from '../../context/signup'
import { useSnackbar } from '../../context/snackbar'
import { useProjectId } from '../../hooks/useProjectId'

export const InterestsPage = () => {
  const { nextPage } = useSignup()
  const { showMessage } = useSnackbar()
  const { data: project } = useProject(useProjectId())
  const { data: properties = [] } = useProperties(project?.id)
  const { mutate: createInterests, isPending } = useCreateInterests()

  const handleSubmit = (interests) =>
    createInterests(interests, {
      onSuccess: () => nextPage(),
      onError: (error) => showMessage(error.message),
    })

  return (
    <InterestsPageComponent
      project={project}
      properties={properties}
      loading={isPending}
      onSubmit={handleSubmit}
    />
  )
}
